import React from 'react';
import { Evidence2 } from '@eas/common-web';
import { useValidationSchema } from './uform-gov-service-schema';
import { UFormGovService } from '../../models';
import { PageKey, EvidenceAPI } from '../../enums';
import { ExportTags } from '../../enums/export-tags';
import { UFormGovServiceFields } from './uform-gov-service-fields';
import { useDictionaryEvidence } from '../../components/evidence/dictionary-evidence/dictionary-evidence';
import { usePermission } from '../../components/permission/perm-evidence-hook';
import { DictionaryActionbar } from '../../components/evidence/dictionary-evidence/dictionary-actionbar';
import { UFormGovServiceActionbar } from './uform-gov-actionbar';

export function UFormGovServices() {
  const validationSchema = useValidationSchema();

  const permissions = usePermission<UFormGovService>({
    options: {
      NEW: [],
      EDIT: [],
      REMOVE: [],
      CHECK: [],
      SAVE: [],
      CLOSE: [],
    },
  });

  const evidence = useDictionaryEvidence<UFormGovService>({
    identifier: PageKey.UFORM_GOV_SERVICE,
    apiProps: {
      url: EvidenceAPI.UFORM_GOV_SERVICE,
    },
    tableProps: {
      tableName: 'Služby',
      reportTag: ExportTags.UFORM_GOV_SERVICE,
      defaultSorts: [],
    },
    detailProps: {
      codePrefix: 'SERVICE',
      validationSchema,
      GeneralFieldsComponent: UFormGovServiceFields,
      toolbarProps: {
        title: 'Služba',
        showBtn: permissions,
        ActionBar: function ActionBar() {
          return (
            <DictionaryActionbar
              url={EvidenceAPI.UFORM_GOV_SERVICE}
              CustomActions={UFormGovServiceActionbar}
            />
          );
        },
      },
    },
  });

  return <Evidence2 {...evidence} />;
}
